var map = {
	"./PurchaseReturnDetails": [
		"79Va",
		21
	],
	"./PurchaseReturnDetails.vue": [
		"79Va",
		21
	],
	"./purOrderDetails": [
		"U9SR",
		0,
		25
	],
	"./purOrderDetails.vue": [
		"U9SR",
		0,
		25
	],
	"./supply": [
		"SLZ8",
		10
	],
	"./supply.vue": [
		"SLZ8",
		10
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "o4Ma";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/view/procurement/details lazy ^\.\/.*$
// module id = o4Ma
// module chunks = 191